const tbs_model_vo_StageTeam = function() {
}

tbs_model_vo_StageTeam.prototype = {
    /* The view object name */
    name: 'team',
    /* The view object instance */
    view: {
        query: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'AdminGetBMMatchStageTeamList',
            query: {
                matchId: 'matchGroupId',
                stageId: 'stageId',
            },
            basePath: 'data.teams',
            rule: {
                id: 'id',
                logoUrl: 'badge',
                name: 'name',
                homeTeamSuit: '$clothesIds',
                awayTeamSuit: '$clothesIds',
                groupId: 'groupId',
            }
        },
        getRoundList: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'getBMMatchGameRoundList',
            query: {
                matchId: 'matchGroupId'
            },
            method: 'get',
            basePath: 'data.list',
            rule: {
                isGroupRound: '@isGroupGame',
                round: '~round',
                stageId: '~stageId'
            }
        },
        getGroupList: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'AdminGetBMMatchStageGroupList',
            query: {
                matchId: 'matchGroupId',
                stageId: 'stageId',
                includeTeamInfo: '(false)',
            },
            basePath: 'data.list',
            rule: {
                value: 'id',
                label: 'name',
            }
        },
    },
    //--------------------------------------------------
    // private method
    //--------------------------------------------------
    renderHomeTeamSuit: function(clothesIds) {
        clothesIds = clothesIds || ','
        return clothesIds.split(',')[0]
    },
    renderAwayTeamSuit: function(clothesIds) {
        clothesIds = clothesIds || ','
        return clothesIds.split(',')[1]
    },
}

module.exports = tbs_model_vo_StageTeam